var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLike = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71094 12.7543L6.96679 14.5509C7.25787 14.8503 7.9128 15 8.34941 15L11.1147 15C11.9879 15 12.9339 14.3263 13.1522 13.428L14.8987 7.96333C15.2625 6.91531 14.6076 6.01701 13.5161 6.01701L10.6053 6.01701C10.1687 6.01701 9.80481 5.64272 9.87758 5.11871L10.2414 2.72325C10.387 2.04953 9.95035 1.30095 9.29542 1.07637C8.71326 0.851796 7.98557 1.15123 7.69449 1.60038L4.71094 6.16673",
    stroke: "#333335",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999998 12.7543L1 5.41816C1 4.37014 1.43662 3.99585 2.45539 3.99585L3.18309 3.99585C4.20186 3.99585 4.63848 4.37014 4.63848 5.41816L4.63848 12.7543C4.63848 13.8023 4.20186 14.1766 3.18308 14.1766L2.45539 14.1766C1.43662 14.1766 0.999998 13.8023 0.999998 12.7543Z",
    stroke: "#333335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLike, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/like.d9fab945.svg";
export { ForwardRef as ReactComponent };